import * as THREE from 'three';
import { t, getLang, setLang, onLangChange } from '../i18n';
import { shareLink } from '../share';
import type { Atmosphere } from '../scene/atmosphere';
import type { Controls } from '../scene/controls';
import type { Band } from '../scene/wallLayout';

const UPDATE_MS = 150;

const IG_URL = 'https://instagram.com/moser.eth';
const FB_URL = 'https://facebook.com/moserwav';
const LINKTREE_URL = 'https://linktr.ee/moser.eth';
const MAIL_URL = 'mailto:kamil.antropik@gmail.com';

// simple-icons 24x24 single-path glyphs (CC0), drawn with fill: currentColor.
const SOCIALS = [
  {
    label: 'Instagram',
    href: IG_URL,
    path: 'M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077',
  },
  {
    label: 'Facebook',
    href: FB_URL,
    path: 'M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z',
  },
  {
    label: 'Linktree',
    href: LINKTREE_URL,
    path: 'm13.73635 5.85251 4.00467-4.11665 2.3248 2.3808-4.20064 4.00466h5.9085v3.30473h-5.9365l4.22865 4.10766-2.3248 2.3338L12.0005 12.099l-5.74052 5.76852-2.3248-2.3248 4.22864-4.10766h-5.9375V8.12132h5.9085L3.93417 4.11666l2.3248-2.3808 4.00468 4.11665V0h3.4727zm-3.4727 10.30614h3.4727V24h-3.4727z',
  },
];

export interface HudOpts {
  isDetailOpen(): boolean;
}

export interface Hud {
  update(): void;
  openWystawaPanel(): void;
}

function getActiveBand(camera: THREE.PerspectiveCamera, bands: Band[]): Band | null {
  if (bands.length === 0) return null;
  const cy = camera.position.y;
  // Pick the band whose Y-range (height up the wall) contains (or is closest to) the camera.
  let best = bands[0];
  let bestDist = Infinity;
  for (const b of bands) {
    const dist = cy < b.yStart ? b.yStart - cy : cy > b.yEnd ? cy - b.yEnd : 0;
    if (dist < bestDist) { bestDist = dist; best = b; }
  }
  return best;
}

export function initHud(
  camera: THREE.PerspectiveCamera,
  bands: Band[],
  controls: Controls,
  atmosphere: Atmosphere,
  opts: HudOpts,
): Hud {
  const el = document.createElement('div');
  el.id = 'hud';
  el.innerHTML = `
    <div class="top">
      <span class="cluster-name"></span>
      <button class="brand" aria-label="MOSER"><img class="brand-logo" src="${import.meta.env.BASE_URL}logo-moser.png" alt="MOSER" /></button>
      <div class="top-right">
        <a class="alt-view" href="${import.meta.env.BASE_URL}" title="Galeria 2D">2D</a>
        <button class="lang"></button>
      </div>
    </div>
    <div class="bottom">
      <a class="wystawa-link" role="button" tabindex="0"></a>
    </div>`;
  document.body.appendChild(el);

  const panel = document.createElement('div');
  panel.className = 'wystawa-panel';
  panel.innerHTML = `
    <p class="wystawa-info"></p>
    <dl class="wystawa-meta"></dl>
    <div class="wystawa-actions">
      <button type="button" class="wystawa-calendar" hidden></button>
      <button type="button" class="wystawa-share"></button>
    </div>`;
  document.body.appendChild(panel);
  const infoEl = panel.querySelector('.wystawa-info') as HTMLParagraphElement;
  const metaEl = panel.querySelector('.wystawa-meta') as HTMLDListElement;
  const calendarBtn = panel.querySelector('.wystawa-calendar') as HTMLButtonElement;
  const wystawaShareBtn = panel.querySelector('.wystawa-share') as HTMLButtonElement;

  const about = document.createElement('div');
  about.className = 'about-panel';
  about.innerHTML = `
    <h2 class="wordmark">MOSER</h2>
    <p class="about-subtitle"></p>
    <p class="statement statement2"></p>
    <p class="statement"></p>
    <p class="statement statement3"></p>
    <p class="signature">— Moser</p>
    <p class="links">
      <a class="ig" target="_blank" rel="noopener"></a>
      <a class="mail"></a>
    </p>`;
  document.body.appendChild(about);
  const igLink = about.querySelector('.ig') as HTMLAnchorElement;
  const mailLink = about.querySelector('.mail') as HTMLAnchorElement;
  igLink.href = IG_URL;
  mailLink.href = MAIL_URL;

  // Floating social rail, bottom-left corner (above the wystawa CTA).
  const social = document.createElement('div');
  social.className = 'social-rail';
  social.innerHTML = SOCIALS.map(
    (s) =>
      `<a class="social-link" href="${s.href}" target="_blank" rel="noopener" aria-label="${s.label}" title="${s.label}">` +
      `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${s.path}"/></svg></a>`,
  ).join('');
  document.body.appendChild(social);

  const nameEl = el.querySelector('.cluster-name') as HTMLSpanElement;
  const langBtn = el.querySelector('.lang') as HTMLButtonElement;
  const link = el.querySelector('.wystawa-link') as HTMLAnchorElement;
  const brandBtn = el.querySelector('.brand') as HTMLButtonElement;

  const renderWystawaMeta = () => {
    const date = t('wystawaDate');
    const venue = t('wystawaVenue');
    metaEl.innerHTML = '';
    if (date) {
      metaEl.innerHTML += `<dt>${t('wystawaDateLabel')}</dt><dd>${date}</dd>`;
    }
    if (venue) {
      metaEl.innerHTML += `<dt>${t('wystawaVenueLabel')}</dt><dd>${venue}</dd>`;
    }
    metaEl.style.display = date || venue ? '' : 'none';
    calendarBtn.hidden = !date;
    if (date && !calendarBtn.hidden) {
      const title = encodeURIComponent('Wystawa MOSER — Białystok');
      const details = encodeURIComponent(t('wystawaInfo'));
      const location = encodeURIComponent(venue);
      calendarBtn.onclick = () => {
        window.open(
          `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&details=${details}&location=${location}`,
          '_blank',
          'noopener',
        );
      };
    }
  };

  const applyLang = () => {
    langBtn.textContent = t('langToggle');
    link.textContent = t('wystawaLink');
    infoEl.textContent = t('wystawaInfo');
    calendarBtn.textContent = t('addToCalendar');
    wystawaShareBtn.textContent = t('wystawaShare');
    renderWystawaMeta();
    (about.querySelector('.about-subtitle') as HTMLParagraphElement).textContent = t('aboutSubtitle');
    (about.querySelector('.statement2') as HTMLParagraphElement).textContent = t('aboutStatement2');
    (about.querySelector('.statement:not(.statement2):not(.statement3)') as HTMLParagraphElement).textContent = t('aboutStatement');
    (about.querySelector('.statement3') as HTMLParagraphElement).textContent = t('aboutStatement3');
    igLink.textContent = t('aboutInstagram');
    mailLink.textContent = t('aboutEmail');
  };
  applyLang();
  onLangChange(applyLang);
  langBtn.addEventListener('click', () => setLang(getLang() === 'pl' ? 'en' : 'pl'));
  brandBtn.addEventListener('click', () => about.classList.toggle('open'));
  const closeWystawaPanel = () => panel.classList.remove('open');

  window.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || opts.isDetailOpen()) return;
    if (panel.classList.contains('open')) closeWystawaPanel();
    else if (about.classList.contains('open')) about.classList.remove('open');
  });

  document.addEventListener('pointerdown', (e) => {
    if (!panel.classList.contains('open')) return;
    const target = e.target as Node;
    if (!panel.contains(target) && !link.contains(target)) closeWystawaPanel();
  });

  // The exhibition CTA is the site's whole purpose (turnout at the wernisaż),
  // so it is global — not tied to a band literally named 'wystawa'. Prefer a
  // dedicated 'wystawa' band once curated, else fall back to the first band
  // (nearest end of the wall) so a click still re-centers the view. Shown whenever
  // there is any content.
  const wystawa = bands.find((b) => b.name === 'wystawa') ?? bands[0];
  link.style.display = wystawa ? '' : 'none';
  wystawaShareBtn.addEventListener('click', () => {
    void shareLink({ cluster: 'wystawa' }, t('wystawaLink'));
  });

  const openWystawaPanel = () => {
    if (wystawa) controls.flyToSection(wystawa);
    panel.classList.add('open');
  };

  link.addEventListener('click', () => {
    if (panel.classList.contains('open')) closeWystawaPanel();
    else openWystawaPanel();
  });
  link.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      link.click();
    }
  });

  const compass = document.createElement('div');
  compass.className = 'cluster-compass';
  const compassBtns: HTMLButtonElement[] = [];
  for (const b of bands) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.dataset.cluster = b.name;
    btn.textContent = b.name;
    btn.style.setProperty('--cluster-color', `#${b.color.getHexString()}`);
    btn.addEventListener('click', () => controls.flyToSection(b));
    compass.appendChild(btn);
    compassBtns.push(btn);
  }
  el.appendChild(compass);

  let lastBandName: string | null = null;
  let lastUpdate = 0;
  return {
    openWystawaPanel,
    update(): void {
      const now = performance.now();
      if (now - lastUpdate < UPDATE_MS || bands.length === 0) return;
      lastUpdate = now;
      const best = getActiveBand(camera, bands);
      if (!best) return;
      nameEl.textContent = best.name;
      if (best.name !== lastBandName) {
        atmosphere.pulseCluster(best.name);
        lastBandName = best.name;
      }
      for (const btn of compassBtns) {
        btn.classList.toggle('active', btn.dataset.cluster === best.name);
      }
    },
  };
}
